import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useAuth } from '@/hooks/useAuth';
import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Gates the routes that belong to an owner/manager only. A "pure" instructor
 * (INSTRUCTOR without OWNER/MANAGER) is redirected to "/inicio", their own home
 * screen (lesson summary, upcoming lessons and the MercadoPago connection). A
 * "pure" admin (ADMIN without OWNER/MANAGER/INSTRUCTOR) goes to the backoffice.
 */
export const RequireOwnerOrManager: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isUserReady, isPureInstructor, isPendingDebtOnly, isFutureOwner, isPureAdmin } =
    useAuth();

  // Wait until the roles are known before deciding, so nobody is redirected
  // prematurely. `isLoadingUser` alone is not enough: it starts out false, with
  // the profile still on its way.
  if (!isUserReady) {
    return <LoadingScreen />;
  }

  if (isPendingDebtOnly) {
    return <Navigate to="/cuenta-corriente" replace />;
  }

  if (isPureInstructor) {
    return <Navigate to="/inicio" replace />;
  }

  // A pure ADMIN has no clubs or tournaments, so the owner Home would render
  // empty and fire an owner-only tournaments fetch that answers 403.
  if (isPureAdmin) {
    return <Navigate to="/admin/usuarios" replace />;
  }

  if (isFutureOwner) {
    return <Navigate to="/clubs" replace />;
  }

  return <>{children}</>;
};
